// extracted by mini-css-extract-plugin
export var cardHeader = "_ro-0";
export var reorderHandle = "_ro-3";
export var titleArea = "_ro-1";
export var titleAreaWithHandle = "_ro-2";